module.exports = __webpack_public_path__ + "img/call.ccbc11dc.jpg";